/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SimpleShift } from '../models/SimpleShift';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccordationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Accord Shifts
     * ### Create Accordation
     *
     * Accords all unaccorded shifts of a coach in the current week (from monday to sunday).
     *
     *
     * **Permissions Required**:
     * `accord_shifts`
     * @param coachId
     * @returns SimpleShift Successful Response
     * @throws ApiError
     */
    public patchFspAccordShifts(
        coachId: number,
    ): CancelablePromise<Array<SimpleShift>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/fsp/accordation/{coach_id}/accordation',
            path: {
                'coach_id': coachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Accord Shifts
     * ### Create Accordation
     *
     * Accords all unaccorded shifts of a coach in the current week (from monday to sunday).
     *
     *
     * **Permissions Required**:
     * `accord_shifts`
     * @param coachId
     * @returns SimpleShift Successful Response
     * @throws ApiError
     */
    public patchFspAccordShiftsVLatest(
        coachId: number,
    ): CancelablePromise<Array<SimpleShift>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/fsp/accordation/{coach_id}/accordation',
            path: {
                'coach_id': coachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
